export default __webpack_public_path__ + "static/media/multi-shipping.d3d99987.svg";